"use strict";

var _objectSpread = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _defineProperty = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _exports$PLATFORM_CON;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmailConfirmationRequired = exports.isDeliverySupported = exports.isPaymentRequired = exports.getConfigurationByPlatform = exports.PLATFORM_CONFIGURATION = exports.DEFAULT_PLATFORM_CONFIGURATION = void 0;

var types_1 = require("../types");

exports.DEFAULT_PLATFORM_CONFIGURATION = {
  isDeliverySupported: true,
  isEmailConfirmationRequired: true,
  isPaymentRequired: true
};
exports.PLATFORM_CONFIGURATION = (_exports$PLATFORM_CON = {}, _defineProperty(_exports$PLATFORM_CON, types_1.Platform.waitr, {
  isDeliverySupported: false,
  isEmailConfirmationRequired: false,
  isPaymentRequired: false
}), _defineProperty(_exports$PLATFORM_CON, types_1.Platform.grubhub, {
  isDeliverySupported: false,
  isEmailConfirmationRequired: false,
  isPaymentRequired: false
}), _defineProperty(_exports$PLATFORM_CON, types_1.Platform.uber, {
  isDeliverySupported: false,
  isEmailConfirmationRequired: false,
  isPaymentRequired: false
}), _exports$PLATFORM_CON);
/**
 * Takes an order cart and returns fulfillment configuration for the correct platform
 * @param {Platform}
 * @returns a configuration object
 */

function getConfigurationByPlatform(platform) {
  var config = platform && exports.PLATFORM_CONFIGURATION[platform];

  if (!config) {
    return _objectSpread(_objectSpread({}, exports.DEFAULT_PLATFORM_CONFIGURATION), {}, {
      isDefault: true
    });
  }

  return _objectSpread(_objectSpread({}, config), {}, {
    isDefault: false
  });
}

exports.getConfigurationByPlatform = getConfigurationByPlatform;
/**
 * Returns a tuple of result, default stating if the payment is required
 * for the given platform
 */

function isPaymentRequired(platform) {
  var _getConfigurationByPl = getConfigurationByPlatform(platform),
      isPaymentRequired = _getConfigurationByPl.isPaymentRequired,
      isDefault = _getConfigurationByPl.isDefault;

  return {
    isDefault: isDefault,
    result: isPaymentRequired
  };
}

exports.isPaymentRequired = isPaymentRequired;
/**
 * Returns a tuple of result, default stating if delivery is required
 * for the given platform
 */

function isDeliverySupported(platform) {
  var _getConfigurationByPl2 = getConfigurationByPlatform(platform),
      isDeliverySupported = _getConfigurationByPl2.isDeliverySupported,
      isDefault = _getConfigurationByPl2.isDefault;

  return {
    isDefault: isDefault,
    result: isDeliverySupported
  };
}

exports.isDeliverySupported = isDeliverySupported;
/**
 * Returns a tuple of result, default stating if the email confirmation
 * is required for the given platform
 */

function isEmailConfirmationRequired(platform) {
  var _getConfigurationByPl3 = getConfigurationByPlatform(platform),
      isEmailConfirmationRequired = _getConfigurationByPl3.isEmailConfirmationRequired,
      isDefault = _getConfigurationByPl3.isDefault;

  return {
    isDefault: isDefault,
    result: isEmailConfirmationRequired
  };
}

exports.isEmailConfirmationRequired = isEmailConfirmationRequired;